import { TableNumberBox, TableTextBox } from '@/components/control'
import { DataGridCellProps } from '../types'

function DataGridCell ( props: DataGridCellProps ) {
    const {
        idx, data, field, width, textAlign, type, rowData,
        setRowData,
    } = props

    const onCustomChange = ( value: string | number ): void => {
        data[ field ] = value
        rowData[ idx ] = data
        setRowData( rowData )
    }

    return (
        <div className="data-grid-cell" style={ { width } }>
            {
                type === 'number' ?
                    <TableNumberBox
                        value={ Number( data[ field ] || 0 ) }
                        style={ { textAlign } }
                        onChange={ onCustomChange }
                    /> :
                    <TableTextBox
                        value={ data[ field ] }
                        style={ { textAlign } }
                        onChange={ onCustomChange }
                    />
            }
        </div>
    )
}

export default DataGridCell